import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { ContainerEnum } from 'app/models/container.enum';
import { Container } from 'app/models/container.model';
import { Device } from 'app/models/device.model';
import { Poligon, PoligonDetail } from 'app/models/poligon.model';
import { CompanyService } from 'app/services/company.service';
import { ContainerService } from 'app/services/container.service';
import { CoordinatesFromAddressService } from 'app/services/coordinates-from-address.service';
import { DeviceService } from 'app/services/device.service';
import { PoligonService } from 'app/services/poligon.service';
import { SimulationService } from 'app/services/simulation.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import { BaseFormComponent } from '../../../base-form.component';
import { SimulationContainerLocationFormComponent } from '../container-location-form/container-location-form.component';

@Component({
    selector: 'app-container-form',
    templateUrl: './container-form.component.html',
    styleUrls: ['./container-form.component.scss']
})
export class SimulationContainerFormComponent extends BaseFormComponent implements OnInit {
    public _changeDevice: string
    public companyId:number;
    public selectedCompany: number;
    public companyList: Array<Company>
    public selectedLocation: L.LatLng;
    public poligonList: Array<Poligon>
    public _containerEnum:ContainerEnum;
    public get containerEnum(): typeof ContainerEnum {
        return ContainerEnum; 
      }
    public get changeDevice() {
        return this._changeDevice
    }
    public set changeDevice(d: string) {
        this._changeDevice = d
    }

    public _selectedPoligon: number;
    public get selectedPoligon() {
        return this._selectedPoligon
    }
    public set selectedPoligon(v: number) {
        this._selectedPoligon = v
    }
    private _container: Container = {
        street: undefined,
        streetDesc: undefined,
        neighbor: undefined,
        rootType: undefined,
    }
    private _deviceList: Array<Device> = [];
    public get model() {
        return this._container
    }
    public set model(v: Container) {
        this._container = v;
    }
    constructor(
        private _dialog: MatDialog,
        private toasterService: ToasterService,
        private _coordinatesFromAddressService:CoordinatesFromAddressService,
        private _simulationService: SimulationService,
        private _companyService: CompanyService,
        private _translateService:TranslateService
    ) {
        super();
    }


    public async ngOnInit() {
        this.companyId=parseInt(localStorage.getItem("CompanyID"));
        this.model.status =true;

        this.getPoligonList(this.companyId);
        if (this.operation == "update") {
            try {
                var poligon = await this._simulationService.getByPoligonDetail(this.model.id);
                poligon.forEach(z => this.selectedPoligon = z.poligonId);
            } catch (error) {
                console.warn(error);

            }
            this.selectedCompany=this.model.companyId;
            this.getPoligonList(this.selectedCompany);
        }
        if (parseInt(localStorage.getItem("CompanyID")) == 1) {
            try {
                this.companyList = await this._companyService.getCompanies();

            } catch (error) {
                console.warn(error);

            }
        }
    }

    public async onCompanyChange(id){
        this.getPoligonList(id);
    }

    public async getPoligonList(companyId:number){
        try {
            this.poligonList = await this._simulationService.getPoligons(companyId);
        } catch (error) {
            console.warn(error);
        }
    }

    public async getCoordinateFromAddress(){
        var address = await this._coordinatesFromAddressService.getAddress(this.model.latitude,this.model.longitude)
        if(address.address.town){
            this.model.neighbor = address.address.town;
            this.model.streetDesc = address.address.town
        }
        if(address.address.suburb){
            this.model.street = address.address.suburb
            this.model.streetDesc += (' / '+ address.address.suburb)
        }
        if(address.address.road){
            this.model.street += ((this.model.street?' / ':'') + address.address.road)
            this.model.streetDesc += (' / ' + address.address.road)

        }
    }

    public async save() {
        if (this.form.invalid) {
            this.toasterService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
                );
                return;
            }
            
            if(this.model.altitude<=this.model.deadZone){
                this.toasterService.toastWarning(
                    this._translateService.instant("DEAD_ZONE_LESS_ALTITUDE")
                )
                return;
            }
            
            var toDate = new Date
            var full_date = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(),toDate.getHours(),toDate.getMinutes(),toDate.getSeconds(),toDate.getMilliseconds());
            var rn=Math.floor(Math.random()*1000000);
            var time = full_date.getTime();
            var deviceId = "0"+(time.toString()+rn.toString()).slice(5, 20);

        this.model.companyId = parseInt(localStorage.getItem("CompanyID")) == 1 ? this.selectedCompany : parseInt(localStorage.getItem("CompanyID"));
        this.model.status=true;

        this.model.dDate = new Date()
        this.model.deviceId = deviceId;
        this.model.simulation=true;
        let response;
        if (this.operation == "create") {
            try {
                await this.setDeviceMultiple(this.model.companyId,this.model.deviceId);
                response = await this._simulationService.addContainer(this.model)
            } catch (error) {
                console.warn(error);
                this.added.emit(false);
            }
            if (this.selectedPoligon != undefined) {
                let poligonDetail = new PoligonDetail();
                poligonDetail.discriminator = "container"
                poligonDetail.discriminatorId = response.id
                poligonDetail.poligonId = this.selectedPoligon;
                try {
                    await this._simulationService.addDetail(poligonDetail);
                    this.added.emit(true);
                } catch (error) {
                    console.warn(error);
                    this.added.emit(false);
                }
            }
            this.added.emit(true);
        }
        else {
            try {
                response = await this._simulationService.updatedContainer(this.model);
            } catch (error) {
                console.warn(error);
            }
            if (this.selectedPoligon != undefined) {
                try {
                    var poligonByDetail = await this._simulationService.getByPoligonDetail(this.model.id)
                    await this._simulationService.removeRange(poligonByDetail)
                } catch (error) {
                    console.warn(error);
                    this.updated.emit(false);
                }
                let poligonDetail = new PoligonDetail();
                poligonDetail.discriminator = "container";
                poligonDetail.discriminatorId = this.model.id;
                poligonDetail.poligonId = this.selectedPoligon;
                try {
                    await this._simulationService.addDetail(poligonDetail);
                    this.updated.emit(true);
                } catch (error) {
                    console.warn(error);
                    this.updated.emit(false);
                }
            }
            this.updated.emit(true);
        }

    }

    async setDeviceMultiple(companyId,deviceId):Promise<string> {
        var _device: Device =
        {
            id: deviceId,
            firmware: "00032",
            model: "2",
            periot: "15",
            shakeCount: "120",
            sonicActive: "1",
            sonicFilte: "10",
            sonicTolerans: "20",
            sonicMeasure: "15",
            msgTyr: "3",
            msgStanby: "35000",
            runType: "1",
            gpsRepeat: "20",
            shakeWait:"3",
            distanceTime:"5",
            distanceValue:"15",
            empty1:"0",
            empty2:"0",
            empty3:"0",
            gpsTime: "25",
            gpsPeriot: "8",
            batMin: "320",
            batGpMin: "380",
            batMultiplier: "1000",
            solarMultiplier: "1000",
            serialNumber: "DP0000000001",
            apn: "internet",
            hostRequestWeb: "http://212.154.111.45:10001",
            hostRequestEXT: "/custom_get_request",
            ssid: "Simulation",
            smsNumber: "5439024474",
            periotTimeOut: "20",
            heatAlarm:"800",
            updated: 0,
            companyId:companyId,
            time:new Date,
            uDate: new Date
        };
        try {
            await this._simulationService.addDevice(_device)
            return deviceId;
        } catch (error) {
            console.warn(error);
            return null;
        }
    }

    public async containerLocation() {
        const dialog = this._dialog.open(SimulationContainerLocationFormComponent, {
            data: { model: this.model },
            disableClose: false
        })
        dialog.componentInstance.operation = "create"
        dialog.afterClosed().subscribe(result => {
            if (result != undefined) {
                this.model.latitude = result.lat;
                this.model.longitude = result.lng;
                this.getCoordinateFromAddress();
            }
        })
    }

}
